import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import React from 'react';
import { useSelector } from 'react-redux';
import { isTestPeriodShownSelector } from '../../../reducers/EditorReducer/EditorSelector';
import { StateType } from '../../../reducers';
import analytics from '../../../shared/services/analytics/analytics';

interface TestingPeriodControlProps {
  onChangeTestPeriodShown: (isTestPeriodShown: boolean) => {};
  path: string[];
  eventLabel?: string;
}

export function TestPeriodControl({ onChangeTestPeriodShown, path, eventLabel }: TestingPeriodControlProps) {
  const handleButtonClick = () => {
    analytics.trackCustomEvent(isTestPeriodShown ? 'sim_click_hide_test_period' : 'sim_click_show_test_period', {
      event_label: eventLabel,
    });
    onChangeTestPeriodShown(!isTestPeriodShown);
  };

  const isTestPeriodShown = useSelector((state: StateType) => isTestPeriodShownSelector(state, { path }));

  return (
    <div className="alphas-details__test-period-control">
      <button className="button button--secondary intro-step-7-1" onClick={handleButtonClick}>
        {isTestPeriodShown ? (
          <FormattedMessageHelper id="alphaDetails.hideTestPeriod" />
        ) : (
          <FormattedMessageHelper id="alphaDetails.revealTestPeriod" />
        )}
      </button>
      <span>
        <FormattedMessageHelper id="alphaDetails.testPeriodExplanation" />
      </span>
    </div>
  );
}
